import * as React from 'react';
import { inject, observer } from 'mobx-react';
import styled from 'styled-components';
import { colors } from 'kaizen-ui-colors/lib';
import { elevation4 } from '../sharedStyle/elevation';
import { LoadingScreen } from './LoadingScreen';
import { ErrorScreen } from './ErrorScreen';
import { OnboardingScreen } from './OnboardingScreen';
import { AppToolbar } from './AppToolbar';
import { HeaderBar } from './HeaderBar';
import { ExperienceTable } from './ExperienceTable';
import { IStore } from '../../domain/store';

interface IProps {
  store?: IStore;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const Header = styled.div`
  ${elevation4};
  z-index: 3;
`;

const Body = styled.div`
  flex-grow: 1;
  padding: 24px 0 28px;
  background-color: ${colors.mochi_dark__ebedef};
  min-width: 750px;
`;

@inject('store')
@observer
export class AppContainer extends React.Component<IProps, {}> {
  private store: IStore;

  constructor(props: IProps) {
    super(props);
    this.store = props.store!;
  }

  public render() {
    const { uiState } = this.store;
    return (
      <Container>
        <Header>
          <HeaderBar />
        </Header>
        <Body>
          {!uiState.isReady && !uiState.hasError ? <LoadingScreen /> : null}
          {uiState.isReady && uiState.hasError ? (
            <ErrorScreen
              title={uiState.error.title}
              message={uiState.error.message}
              actionLabel={uiState.error.actionLabel}
              action={uiState.error.action}
              showEmptyStateImage={uiState.error.showEmptyStateImage}
            />
          ) : null}
          {uiState.isReady && !uiState.hasError && uiState.showOnboardingScreen ? <OnboardingScreen /> : null}
          {uiState.isReady && !uiState.hasError && !uiState.showOnboardingScreen ? (
            <React.Fragment>
              <AppToolbar />
              <ExperienceTable />
            </React.Fragment>
          ) : null}
        </Body>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/AppContainer.tsx